import { Layout, GreenWaves as GreenWavesComponent } from "components"
export const GreenWaves = () => {
 return (
  <Layout>
   <GreenWavesComponent />
  </Layout>
 )
}
